<section class="banner-style-one">
  <div class="parallax"
       style="background-image: url(/assets/images/about.png);"></div>

  <div class="breadcrums">
    <div class="container">
      <div class="row">
        <ul>
          <li>
            <a [routerLink]="['/']">
              <i class="fa-solid fa-house"></i>
              <p>Inicio</p>
            </a>
          </li>
          <li class="current">
            <p>Entrena con nosotros</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<app-timetable-schedule></app-timetable-schedule>
